/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

tinymce.addI18n('ar_SA', {
  Cut: '\u0642\u0635',
  'Heading 5': '\u0631\u0623\u0633 \u0642\u0644\u0645 5',
  'Header 2': '\u0639\u0646\u0648\u0627\u0646 2',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": '\u0645\u062a\u0635\u0641\u062d\u0643 \u0644\u0627 \u064a\u062f\u0639\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0625\u0644\u0649 \u0627\u0644\u062d\u0627\u0641\u0638\u0629. \u0627\u0644\u0631\u062c\u0627\u0621 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u062e\u062a\u0635\u0627\u0631\u0627\u062a \u0644\u0648\u062d\u0629 \u0627\u0644\u0645\u0641\u0627\u062a\u064a\u062d Ctrl+X/C/V \u0628\u062f\u0644\u0627 \u0645\u0646 \u0630\u0644\u0643.',
  'Heading 4': '\u0631\u0623\u0633 \u0642\u0644\u0645 4',
  Div: '\u062a\u0642\u0633\u064a\u0645',
  'Heading 2': '\u0631\u0623\u0633 \u0642\u0644\u0645 2',
  Paste: '\u0644\u0635\u0642',
  Close: '\u0623\u063a\u0644\u0642',
  'Font Family': '\u0639\u0627\u0626\u0644\u0629 \u0627\u0644\u062e\u0637\u0648\u0637',
  Pre: '\u0645\u0627\u0642\u0628\u0644',
  'Align right': '\u0645\u062d\u0627\u0630\u0627\u0629 \u0644\u0644\u064a\u0645\u064a\u0646',
  'New document': '\u0645\u0644\u0641 \u062c\u062f\u064a\u062f',
  Blockquote: '\u0625\u0642\u062a\u0628\u0627\u0633 \u062e\u0627\u0631\u062c\u064a',
  'Numbered list': '\u0644\u0627\u0626\u062d\u0629 \u0645\u0631\u0642\u0651\u0645\u0629',
  'Heading 1': '\u0631\u0623\u0633 \u0642\u0644\u0645 1',
  Headings: '\u0631\u0624\u0648\u0633 \u0623\u0642\u0644\u0627\u0645',
  'Increase indent': '\u0632\u064a\u0627\u062f\u0629 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062f\u0626\u0629',
  Formats: '\u0627\u0644\u062a\u0646\u0633\u064a\u0642\u0627\u062a',
  Headers: '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646',
  'Select all': '\u0623\u062e\u062a\u0631 \u0627\u0644\u0643\u0644',
  'Header 3': '\u0639\u0646\u0648\u0627\u0646 3',
  Blocks: '\u0627\u0644\u0628\u0644\u0648\u0643\u0627\u062a',
  Undo: '\u062a\u0631\u0627\u062c\u0639',
  Strikethrough: '\u0639\u0644\u064a\u0647 \u062e\u0637',
  'Bullet list': '\u0644\u0627\u0626\u062d\u0629 \u0645\u0646\u0642\u0651\u0637\u0629',
  'Header 1': '\u0639\u0646\u0648\u0627\u0646 1',
  Superscript: '\u0641\u0648\u0642 \u0627\u0644\u0646\u0635',
  'Clear formatting': '\u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u062a\u0646\u0633\u064a\u0642',
  'Font Sizes': '\u0623\u062d\u062c\u0627\u0645 \u0627\u0644\u062e\u0637\u0648\u0637',
  Subscript: '\u062a\u062d\u062a \u0627\u0644\u0646\u0635',
  'Header 6': '\u0639\u0646\u0648\u0627\u0646 6',
  Redo: '\u0625\u0639\u0627\u062f\u0629',
  Paragraph: '\u0641\u0642\u0631\u0629',
  Ok: '\u062d\u0633\u0646\u0627\u064b',
  Bold: '\u0639\u0631\u064a\u0636',
  Code: '\u0643\u0648\u062f',
  Italic: '\u0645\u0627\u0626\u0644',
  'Align center': '\u0645\u062d\u0627\u0630\u0627\u0629 \u0644\u0644\u0645\u0646\u062a\u0635\u0641',
  'Header 5': '\u0639\u0646\u0648\u0627\u0646 5',
  'Heading 6': '\u0631\u0623\u0633 \u0642\u0644\u0645 6',
  'Heading 3': '\u0631\u0623\u0633 \u0642\u0644\u0645 3',
  'Decrease indent': '\u062a\u0642\u0644\u064a\u0635 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062f\u0626\u0629',
  'Header 4': '\u0639\u0646\u0648\u0627\u0646 4',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.',
  Underline: '\u062a\u062d\u062a\u0647 \u062e\u0637',
  Cancel: '\u0625\u0644\u063a\u0627\u0621',
  Justify: '\u0627\u0644\u0645\u0633\u0627\u0648\u0627\u0629',
  Inline: '\u0639\u0644\u0649 \u062e\u0637 \u0648\u0627\u062d\u062f',
  Copy: '\u0646\u0633\u062e',
  'Align left': '\u0645\u062d\u0627\u0630\u0627\u0629 \u0644\u0644\u064a\u0633\u0627\u0631',
  'Visual aids': '\u0627\u0644\u0645\u0633\u0627\u0639\u062f\u0627\u062a \u0627\u0644\u0628\u0635\u0631\u064a\u0629',
  'Lower Greek': 'Lower Greek',
  Square: 'Square',
  Default: 'Default',
  'Lower Alpha': 'Lower Alpha',
  Circle: 'Circle',
  Disc: 'Disc',
  'Upper Alpha': 'Upper Alpha',
  'Upper Roman': 'Upper Roman',
  'Lower Roman': 'Lower Roman',
  Name: 'Name',
  Anchor: 'Anchor',
  'You have unsaved changes are you sure you want to navigate away?': '\u0644\u062f\u064a\u0643 \u062a\u063a\u064a\u064a\u0631\u0627\u062a \u0644\u0645 \u064a\u062a\u0645 \u062d\u0641\u0638\u0647\u0627 \u0647\u0644 \u0623\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0623\u0646\u0643 \u062a\u0631\u063a\u0628 \u0641\u064a \u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u061f',
  'Restore last draft': '\u0627\u0633\u062a\u0639\u0627\u062f\u0629 \u0623\u062e\u0631 \u0645\u0633\u0648\u062f\u0629',
  'Special character': 'Special character',
  'Source code': '\u0627\u0644\u0643\u0648\u062f \u0627\u0644\u0645\u0635\u062f\u0631\u064a',
  B: '\u0627\u0644\u0623\u0632\u0631\u0642',
  R: '\u0627\u0644\u0623\u062d\u0645\u0631',
  G: '\u0627\u0644\u0623\u062e\u0636\u0631',
  Color: '\u062a\u062d\u062f\u064a\u062f \u0627\u0644\u0644\u0648\u0646',
  'Right to left': '\u0645\u0646 \u0627\u0644\u064a\u0645\u064a\u0646 \u0625\u0644\u064a \u0627\u0644\u064a\u0633\u0627\u0631',
  'Left to right': '\u0645\u0646 \u0627\u0644\u064a\u0633\u0627\u0631 \u0625\u0644\u064a \u0627\u0644\u064a\u0645\u064a\u0646',
  Emoticons: '\u0627\u0644\u0631\u0645\u0648\u0632',
  Robots: 'Robots',
  'Document properties': '\u062e\u0635\u0627\u0626\u0635 \u0627\u0644\u0645\u0633\u062a\u0646\u062f',
  Title: '\u0639\u0646\u0648\u0627\u0646',
  Keywords: 'Keywords',
  Encoding: '\u062a\u0631\u0645\u064a\u0632',
  Description: 'Description',
  Author: '\u0627\u0644\u0643\u0627\u062a\u0628',
  Fullscreen: 'Fullscreen',
  'Horizontal line': '\u062e\u0637 \u0623\u0641\u0642\u064a',
  'Horizontal space': '\u0627\u0644\u0645\u0633\u0627\u062d\u0629 \u0627\u0644\u0623\u0641\u0642\u064a\u0629',
  'Insert/edit image': '\u0625\u062f\u0631\u0627\u062c/\u062a\u0639\u062f\u064a\u0644 \u0635\u0648\u0631\u0629',
  General: 'General',
  Advanced: '\u0645\u062a\u0642\u062f\u0645',
  Source: '\u0645\u0635\u062f\u0631 \u0627\u0644\u0635\u0648\u0631\u0629',
  Border: 'Border',
  'Constrain proportions': 'Constrain proportions',
  'Vertical space': '\u0627\u0644\u0645\u0633\u0627\u062d\u0629 \u0627\u0644\u0639\u0645\u0648\u062f\u064a\u0629',
  'Image description': '\u0648\u0635\u0641 \u0627\u0644\u0635\u0648\u0631\u0629',
  Style: '\u0627\u0644\u0623\u0633\u0644\u0648\u0628',
  Dimensions: 'Dimensions',
  'Insert image': '\u0625\u062f\u0631\u0627\u062c \u0635\u0648\u0631\u0629',
  'Insert date/time': 'Insert date/time',
  'Remove link': 'Remove link',
  Url: 'Url',
  'Text to display': 'Text to display',
  Anchors: 'Anchors',
  'Insert link': 'Insert link',
  'New window': 'New window',
  None: 'None',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?': 'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?',
  Target: 'Target',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
  'Insert/edit link': 'Insert/edit link',
  'Insert/edit video': 'Insert/edit video',
  Poster: 'Poster',
  'Alternative source': 'Alternative source',
  'Paste your embed code below:': 'Paste your embed code below:',
  'Insert video': 'Insert video',
  Embed: 'Embed',
  'Nonbreaking space': 'Nonbreaking space',
  'Page break': 'Page break',
  'Paste as text': 'Paste as text',
  Preview: '\u0639\u0631\u0636',
  Print: '\u0637\u0628\u0627\u0639\u0629',
  Save: '\u062d\u0641\u0638',
  'Could not find the specified string.': 'Could not find the specified string.',
  Replace: 'Replace',
  Next: 'Next',
  'Whole words': 'Whole words',
  'Find and replace': 'Find and replace',
  'Replace with': 'Replace with',
  Find: 'Find',
  'Replace all': 'Replace all',
  'Match case': 'Match case',
  Prev: 'Prev',
  Spellcheck: 'Spellcheck',
  Finish: 'Finish',
  'Ignore all': 'Ignore all',
  Ignore: 'Ignore',
  'Insert row before': 'Insert row before',
  Rows: 'Rows',
  Height: 'Height',
  'Paste row after': 'Paste row after',
  Alignment: 'Alignment',
  'Column group': 'Column group',
  Row: 'Row',
  'Insert column before': 'Insert column before',
  'Split cell': 'Split cell',
  'Cell padding': 'Cell padding',
  'Cell spacing': 'Cell spacing',
  'Row type': 'Row type',
  'Insert table': 'Insert table',
  Body: 'Body',
  Caption: 'Caption',
  Footer: 'Footer',
  'Delete row': 'Delete row',
  'Paste row before': 'Paste row before',
  Scope: 'Scope',
  'Delete table': 'Delete table',
  'Header cell': 'Header cell',
  Column: 'Column',
  'Cut column': '\u0642\u0635 \u0627\u0644\u0639\u0645\u0648\u062f',
  'Copy column': '\u0646\u0633\u062e \u0627\u0644\u0639\u0645\u0648\u062f',
  'Paste column before': '\u0644\u0635\u0642 \u0627\u0644\u0639\u0645\u0648\u062f \u0642\u0628\u0644',
  'Paste column after': '\u0644\u0635\u0642 \u0627\u0644\u0639\u0645\u0648\u062f \u0628\u0639\u062f',
  Cell: 'Cell',
  Header: 'Header',
  'Cell type': 'Cell type',
  'Copy row': 'Copy row',
  'Row properties': 'Row properties',
  'Table properties': 'Table properties',
  'Row group': 'Row group',
  Right: 'Right',
  'Insert column after': 'Insert column after',
  Cols: 'Cols',
  'Insert row after': 'Insert row after',
  Width: 'Width',
  'Cell properties': 'Cell properties',
  Left: 'Left',
  'Cut row': 'Cut row',
  'Delete column': 'Delete column',
  Center: 'Center',
  'Merge cells': 'Merge cells',
  'Insert template': 'Insert template',
  Templates: 'Templates',
  'Background color': '\u0644\u0648\u0646 \u0627\u0644\u062e\u0644\u0641\u064a\u0629',
  'Custom...': '\u062a\u062e\u0635\u064a\u0635...',
  'Custom color': '\u0644\u0648\u0646 \u0645\u062e\u0635\u0635',
  'No color': '\u0628\u0644\u0627 \u0644\u0648\u0646',
  'Text color': '\u0644\u0648\u0646 \u0627\u0644\u0646\u0635',
  'Show blocks': 'Show blocks',
  'Show invisible characters': 'Show invisible characters',
  'Words: {0}': 'Words: {0}',
  Insert: 'Insert',
  File: 'File',
  Edit: 'Edit',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': 'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help',
  Tools: 'Tools',
  View: 'View',
  Table: 'Table',
  Format: 'Format',
  _dir: 'rtl'
});